import { AxiosError, HttpStatusCode } from 'axios';
import { useMutation } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

import { UserResetPasswordDto } from '../dto/UserResetPasswordDto';

export const useResetPasswordMutation = () => {
  const { users } = useAvApi();

  return useMutation<boolean, AxiosError, UserResetPasswordDto>({
    mutationKey: ['users', 'reset-password'],
    mutationFn: async ({ email }) => {
      const { status } = await users.postV2UsersPasswordReset({
        email
      });

      return status === HttpStatusCode.Ok || status === HttpStatusCode.Created;
    },
  });
};
